import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import the main translation files
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import jaTranslation from './locales/ja/translation.json';
import svTranslation from './locales/sv/translation.json';

// Import the namespaces
import enWhySwitch from './locales/en/whySwitch.json';
import esWhySwitch from './locales/es/whySwitch.json';
import deWhySwitch from './locales/de/whySwitch.json';
import frWhySwitch from './locales/fr/whySwitch.json';
import jaWhySwitch from './locales/ja/whySwitch.json';
import svWhySwitch from './locales/sv/whySwitch.json';

// Import the alternatives namespace
import enAlternativ from './locales/en/alternativ.json';
import esAlternativ from './locales/es/alternativ.json';
import deAlternativ from './locales/de/alternativ.json';
import frAlternativ from './locales/fr/alternativ.json';
import jaAlternativ from './locales/ja/alternativ.json';
import svAlternativ from './locales/sv/alternativ.json';

// Import the alternative descriptions namespace
import enAltDescriptions from './locales/en/alternativeDescriptions.json';
import deAltDescriptions from './locales/de/alternativeDescriptions.json';
import frAltDescriptions from './locales/fr/alternativeDescriptions.json';
import jaAltDescriptions from './locales/ja/alternativeDescriptions.json';
import svAltDescriptions from './locales/sv/alternativeDescriptions.json';
import esAltDescriptions from './locales/es/alternativeDescriptions.json';

// Import the resources namespace
import enResources from './locales/en/resources.json';
import esResources from './locales/es/resources.json';
import deResources from './locales/de/resources.json';
import frResources from './locales/fr/resources.json';
import jaResources from './locales/ja/resources.json';
import svResources from './locales/sv/resources.json';

// Import the FAQ namespace
import enFaq from './locales/en/faq.json';
import esFaq from './locales/es/faq.json';
import deFaq from './locales/de/faq.json';
import frFaq from './locales/fr/faq.json';
import jaFaq from './locales/ja/faq.json';
import svFaq from './locales/sv/faq.json';

// Import the About namespace
import enAbout from './locales/en/about.json';
import esAbout from './locales/es/about.json';
import deAbout from './locales/de/about.json';
import frAbout from './locales/fr/about.json';
import jaAbout from './locales/ja/about.json';
import svAbout from './locales/sv/about.json';

// Import the Index namespace
import enIndex from './locales/en/index.json';
import esIndex from './locales/es/index.json';
import deIndex from './locales/de/index.json';
import frIndex from './locales/fr/index.json';
import jaIndex from './locales/ja/index.json';
import svIndex from './locales/sv/index.json';

// Import the Cookies namespace
import enCookies from './locales/en/cookies.json';
import esCookies from './locales/es/cookies.json';
import deCookies from './locales/de/cookies.json';
import frCookies from './locales/fr/cookies.json';
import jaCookies from './locales/ja/cookies.json';
import svCookies from './locales/sv/cookies.json';

// Import the Guides namespace
import enGuides from './locales/en/guides.json';
import esGuides from './locales/es/guides.json';
import deGuides from './locales/de/guides.json';
import frGuides from './locales/fr/guides.json';
import jaGuides from './locales/ja/guides.json';
import svGuides from './locales/sv/guides.json';

// Import the Press namespace
import enPress from './locales/en/press.json';
import esPress from './locales/es/press.json';
import dePress from './locales/de/press.json';
import frPress from './locales/fr/press.json';
import jaPress from './locales/ja/press.json';
import svPress from './locales/sv/press.json';

// Import the Course namespace
import enCourse from './locales/en/course.json';
import svCourse from './locales/sv/course.json';
import esCourse from './locales/es/course.json';
import frCourse from './locales/fr/course.json';
import deCourse from './locales/de/course.json';
import jaCourse from './locales/ja/course.json';

// Import the Legal namespace
import enLegal from './locales/en/legal.json';
import svLegal from './locales/sv/legal.json';
import esLegal from './locales/es/legal.json';
import frLegal from './locales/fr/legal.json';
import deLegal from './locales/de/legal.json';
import jaLegal from './locales/ja/legal.json';

// Log for debugging
console.info('Initializing i18next with all namespaces');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
        whySwitch: enWhySwitch,
        alternativ: enAlternativ,
        altDescriptions: enAltDescriptions,
        resources: enResources,
        faq: enFaq,
        about: enAbout,
        index: enIndex,
        cookies: enCookies,
        guides: enGuides,
        press: enPress,
        course: enCourse,
        legal: enLegal
      },
      es: {
        translation: esTranslation,
        whySwitch: esWhySwitch,
        alternativ: esAlternativ,
        altDescriptions: esAltDescriptions,
        resources: esResources,
        faq: esFaq,
        about: esAbout,
        index: esIndex,
        cookies: esCookies,
        guides: esGuides,
        press: esPress,
        course: esCourse,
        legal: esLegal
      },
      de: {
        translation: deTranslation,
        whySwitch: deWhySwitch,
        alternativ: deAlternativ,
        altDescriptions: deAltDescriptions,
        resources: deResources,
        faq: deFaq,
        about: deAbout,
        index: deIndex,
        cookies: deCookies,
        guides: deGuides,
        press: dePress,
        course: deCourse,
        legal: deLegal
      },
      fr: {
        translation: frTranslation,
        whySwitch: frWhySwitch,
        alternativ: frAlternativ,
        altDescriptions: frAltDescriptions,
        resources: frResources,
        faq: frFaq,
        about: frAbout,
        index: frIndex,
        cookies: frCookies,
        guides: frGuides,
        press: frPress,
        course: frCourse,
        legal: frLegal
      },
      ja: {
        translation: jaTranslation,
        whySwitch: jaWhySwitch,
        alternativ: jaAlternativ,
        altDescriptions: jaAltDescriptions,
        resources: jaResources,
        faq: jaFaq,
        about: jaAbout,
        index: jaIndex,
        cookies: jaCookies,
        guides: jaGuides,
        press: jaPress,
        course: jaCourse,
        legal: jaLegal
      },
      sv: {
        translation: svTranslation,
        whySwitch: svWhySwitch,
        alternativ: svAlternativ,
        altDescriptions: svAltDescriptions,
        resources: svResources,
        faq: svFaq,
        about: svAbout,
        index: svIndex,
        cookies: svCookies,
        guides: svGuides,
        press: svPress,
        course: svCourse,
        legal: svLegal
      }
    },
    ns: ['translation', 'whySwitch', 'alternativ', 'altDescriptions', 'resources', 'faq', 'about', 'index', 'cookies', 'guides', 'press', 'course', 'legal'],
    defaultNS: 'translation',
    fallbackLng: 'en',
    debug: true, // Keeping debug mode on to help identify translation issues
    interpolation: {
      escapeValue: false // not needed for React
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Add a language change listener for debugging
i18n.on('languageChanged', (lng) => {
  console.info(`i18next: languageChanged ${lng}`);
});

export default i18n;
